import { defineMessages } from "react-intl";

/**
 * These two statements are equivalent:
 *
 * defineMessagesSimple("prefix",{
 *  name: "Your name",
 *  email: "Your email"
 * })
 *
 * defineMessages({
 *   name: {
 *     id: 'prefix.name',
 *     defaultMessage: 'Your name'
 *   },
 *   email: {
 *     id: 'prefix.email',
 *     defaultMessage: 'Your email'
 *   }
 * });
 *
 * @param prefix String to prefix key
 * @param messages Object of keys and translation text
 * @returns react-intl formatted messages object
 */
export function defineMessagesSimple(
    prefix: string,
    messages: Record<string, string>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tranformedMessages: any = {};
    Object.entries(messages).map(([key, value]) => {
        tranformedMessages[key] = {
            id: `${prefix}.${key}`,
            defaultMessage: value
        } as unknown;
    });
    return defineMessages(tranformedMessages);
}
